const SESSION_TIMEOUT = 5 * 60 * 60 * 1000; // 5 hours in milliseconds

const setSessionTimeout = (callback) => {
  return setTimeout(callback, SESSION_TIMEOUT);
};

const clearSessionTimeout = (timeoutRef) => {
  if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
  }
};

const handleSessionExpiration = (showToastMessage, setSessionExpired) => {
  showToastMessage(
    "Session Expired",
    "Your session is about to expire. Would you like to extend it?",
    "warning"
  );
  setSessionExpired(true);
  localStorage.setItem("sessionExpired", "true");
};

const SESSION_TIMEOUT_ADMIN = 5 * 60 * 60 * 1000;


const setAdminSessionTimeout = (callback) => {
  return setTimeout(callback, SESSION_TIMEOUT_ADMIN);
};

const clearAdminSessionTimeout = (timeoutRef) => {
  if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
  }
};

const handleAdminSessionExpiration = (
  showToastMessage,
  setAdminSessionTimeout
) => {
  showToastMessage(
    "Session Expired",
    "Your session is about to expire. Would you like to extend it?",
    "warning"
  );
  setAdminSessionTimeout(true);
  localStorage.setItem("adminSessionExpired", "true");
};

export {
  setSessionTimeout,
  clearSessionTimeout,
  handleSessionExpiration,
  setAdminSessionTimeout,
  clearAdminSessionTimeout,
  handleAdminSessionExpiration,
};
